import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import login_logo from '../../asset/img/login_logo_img.png';
import Typography from '../../components/common/Typography';
import Button from '../../components/common/Button';
import IdLogin from './IdLogin';
import SMSLogin from './SMSLogin';
import LoginTab from '../../components/LoginTab';
import { LoginStyled } from '../../asset/styled/LoginStyled';
import { formatTime, getAutoSaveDialogConfig } from '../../common/Util';
import { getMobileAgree, setAgree } from '../common/commonSlice';
import { setStep } from '../findPassword/findByPasswordSlice';

const sessionId = sStorage.getItem('sessionId');
const Login = () => {
  const { t } = useTranslation('login');
  const { i18n } = useTranslation();
  const { t: tCommon } = useTranslation('common');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLogin } = useSelector(state => state.login);
  const [time, setTime] = useState(120);
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedLang, setSelectedLang] = useState(i18n.language);

  const tabList = [t('tab2'), t('tab1')];
  const langList = ['ko', 'en'];

  const handleLanguageChange = lang => {
    i18n.changeLanguage(lang);
    setSelectedLang(lang);
  };

  useEffect(() => {
    if (isLogin) {
      // 로그인 성공 시 terms 체크를 먼저 수행
      dispatch(getMobileAgree())
        .unwrap()
        .then(response => {
          const { resultCode } = response;
          if (Number(resultCode) !== 1) {
            navigate('/terms');
          } else {
            dispatch(setAgree(true));
            navigate('/');
          }
        })
        .catch(error => {
          console.error('약관 체크 오류:', error);
          // 에러 처리
        });
    }

    dispatch(setStep(1));
  }, [isLogin]);

  const handleAutoLoginClick = () => {
    dispatch(getAutoSaveDialogConfig(tCommon, 'autoLogin', 'autoLogin'));
  };

  return (
    <LoginStyled>
      <div className="login_container">
        {/* <div className="lang_selector">
          {langList.map(lang => (
            <button
              key={lang}
              onClick={() => handleLanguageChange(lang)}
              className={`lang_btn ${selectedLang === lang ? 'active' : ''}`}>
              {lang === 'ko' ? '한국어' : 'English'}
            </button>
          ))}
        </div> */}
        <div className="displayFlex" style={{ justifyContent: 'space-between' }}>
          <div>
            <Typography className="login_logo_text1">{t('header1')}</Typography>
            <Typography className="login_logo_text2">{t('header2')}</Typography>
          </div>
          <img src={login_logo} alt="login logo" width="145px" />
        </div>
        <div className="displayFlexColumn" style={{ gap: '20px' }}>
          <LoginTab tablist={tabList} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
          {selectedTab === 0 ? <SMSLogin /> : <IdLogin />}
        </div>
      </div>
      <Typography className="login_footer_text1">{t('footer1')}</Typography>
    </LoginStyled>
  );
};

export default Login;
